/**
 * Collection "Load More" button.
 *
 * Replaces numbered pagination on collection pages. Fetches the next page of
 * the collection grid via Shopify's Section Rendering API (?section_id=...),
 * then appends only the new product cards to the bottom of the current grid.
 *
 * Uses a delegated click handler so it keeps working after the facet filters
 * re-render #ProductGridContainer (which replaces the button with a fresh one
 * reset to page 1).
 */
(function () {
  'use strict';

  document.addEventListener('click', function (event) {
    var button = event.target.closest('#load-more-products');
    if (!button) return;
    if (button.classList.contains('loading')) return;

    var currentPage = parseInt(button.dataset.currentPage, 10) || 1;
    var totalPages = parseInt(button.dataset.totalPages, 10) || 1;
    var sectionId = button.dataset.sectionId;
    var nextPage = currentPage + 1;

    // Preserve active facets and sort_by from the current URL.
    var params = new URLSearchParams(window.location.search);
    params.delete('section_id');

    // The visible URL keeps filters + page, but not the internal section_id.
    var visibleParams = new URLSearchParams(params.toString());
    visibleParams.set('page', nextPage);
    var visibleUrl = window.location.pathname + '?' + visibleParams.toString();

    // The fetch URL additionally carries section_id for the Section Rendering API.
    params.set('page', nextPage);
    params.set('section_id', sectionId);
    var fetchUrl = window.location.pathname + '?' + params.toString();

    button.classList.add('loading');
    button.disabled = true;

    fetch(fetchUrl)
      .then(function (response) {
        if (!response.ok) throw new Error('Load more request failed: ' + response.status);
        return response.text();
      })
      .then(function (responseText) {
        var doc = new DOMParser().parseFromString(responseText, 'text/html');
        var newCards = doc.querySelectorAll('#product-grid .product-item');
        var grid = document.getElementById('product-grid');
        var wrap = button.closest('.load-more-wrap');

        // Cards are ordered visually via the flex `order` property
        // (.product-item { order: var(--order) }), and each fetched page
        // restarts its counter at 1. Assign appended cards an inline `order`
        // above every card already on screen so the new batch stacks at the
        // bottom instead of interleaving with existing pages.
        var startOrder = grid.querySelectorAll('.product-item').length;

        newCards.forEach(function (card, index) {
          card.style.order = startOrder + index + 1;
          grid.insertBefore(card, wrap);
        });

        button.dataset.currentPage = nextPage;

        // Reflect the loaded page in the address bar (SEO + back button).
        window.history.replaceState({}, '', visibleUrl);

        // Re-init lazy images and star ratings on the appended cards.
        if (window.lazyLoadInstance && typeof window.lazyLoadInstance.update === 'function') {
          window.lazyLoadInstance.update();
        }
        if (typeof reinitialiseRatingSnippet === 'function') {
          reinitialiseRatingSnippet();
        }

        button.classList.remove('loading');
        button.disabled = false;

        // Hide the button once the last page has been loaded.
        if (nextPage >= totalPages) {
          if (wrap) wrap.remove();
          else button.remove();
        }
      })
      .catch(function (error) {
        console.warn(error);
        button.classList.remove('loading');
        button.disabled = false;
      });
  });
})();
